import { enableJudiHealthBranding } from "./featureFlags";

const CAPITALRX_BRAND_NAME = "Capital Rx";
const JUDI_BRAND_NAME = "Judi Rx";

export const getBrandName = () => {
  return enableJudiHealthBranding() ? JUDI_BRAND_NAME : CAPITALRX_BRAND_NAME;
};
